import { lowerCase, startCase } from 'lodash';

export default {
  toLowerStartCase,
};

function toLowerStartCase(category: string): string {
  return lowerCase(startCase(category)) || '';
}
